export default{
    httpOptions: [
        {
            label: 'http://',
            value: 'http://'
        },
        {
            label: 'https://',
            value: 'https://'
        }
    ],
    idTypeOptions:[
        {
            label:'Foreign permanent resident permit',
            value:'Foreign permanent resident permit'
        },
        {
            label:'Overseas work visa (over 1 year)',
            value:'Overseas work visa (over 1 year)'
        },
        {
            label:'Valid employee certificate ',
            value:'Valid employee certificate '
        }
    ],
    idTypeOptionsEN:[
        // {
        //     label:'Overseas passport',
        //     value:'Overseas passport'
        // },
        // {
        //     label:'HK or Macao I.D. Card',
        //     value:'HK or Macao I.D. Card'
        // },
        // {
        //     label:'Taiwan Compatriot Travel Certificate',
        //     value:'Taiwan Compatriot Travel Certificate'
        // }
        {
            label:'Passport',
            value:'Passport'
        }
    ],
    idTypeOptionsHK:[
        {
            label:'Mainland Travel Permit for Hong Kong and Macao Residents',
            value:'Mainland Travel Permit for Hong Kong and Macao Residents'
        },
        {
            label:'Hong Kong Permanent Identity Card',
            value:'Hong Kong Permanent Identity Card'
        },
        {
            label:'Passport',
            value:'Passport'
        }
    ],
    idTypeOptionsMO:[
        {
            label:'Mainland Travel Permit for Hong Kong and Macao Residents',
            value:'Mainland Travel Permit for Hong Kong and Macao Residents'
        },
        {
            label:'Macau identity card',
            value:'Macau identity card'
        },
        {
            label:'Passport',
            value:'Passport'
        }
    ],
    idTypeOptionsTWN:[
        {
            label:'Mainland travel permit for Taiwan residents',
            value:'Mainland travel permit for Taiwan residents'
        },
        {
            label:'Taiwan identity card',
            value:'Taiwan identity card'
        },
        {
            label:'Passport',
            value:'Passport'
        }
    ],
    idTypeOptionsOnlyEN:[//只能是英文
        {
            label:'Overseas passport',
            value:'Overseas passport'
        },
        {
            label:'HK or Macao I.D. Card',
            value:'HK or Macao I.D. Card'
        },
        {
            label:'Taiwan Compatriot Travel Certificate',
            value:'Taiwan Compatriot Travel Certificate'
        }
    ],
    idTypeOptionsOnlyCN:[//只能是中文
        {
            label:'华侨(持有国外永久居留证,如绿卡,枫叶卡)',
            value:'华侨(持有国外永久居留证,如绿卡,枫叶卡)'
        },
        {
            label:'持有一年以上境外有效工作签证的中国护照',
            value:'持有一年以上境外有效工作签证的中国护照'
        },
        {
            label:'持对外劳动服务公司签发的工作证',
            value:'持对外劳动服务公司签发的工作证'
        }
    ],
    socialMediaOptions:[
        {
            label:'facebook',
            value:'facebook'
        },
        {
            label:'linkedin',
            value:'linkedin'
        },
        {
            label:'instagram',
            value:'instagram'
        },
        {
            label:'pinterest',
            value:'pinterest'
        },
        {
            label:'twitter',
            value:'twitter'
        },
        {
            label:'wechat',
            value:'wechat'
        },
        {
            label:'QQ',
            value:'QQ'
        },
        {
            label:'YouTube',
            value:'YouTube'
        }
    ],
    liveOption:[
        {
            label:'Default',
            value:0
        },
        {
            label:'Latest Live',
            value:1
        },
        {
            label:'Popularity(High-Low)',
            value:2
        },
        {
            label:'Time descending',
            value:3
        }
    ]
}